import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { type QueryKey, useQueryClient } from "@msuite/ui/query";
import { toast } from "@msuite/ui/toast";
import React from "react";
import { AddServiceFulfillmentPartnerModal } from "@/modals/organizations/add-service-fulfillment-partner-modal";

/** Props Interface */
interface ServiceFulfillmentPartnersMenuProps {
	serviceId: string;
	queryKey: QueryKey;
}

export function ServiceFulfillmentPartnersMenu({
	queryKey,
	serviceId,
}: ServiceFulfillmentPartnersMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addServiceFulfillmentPartnerModal = useDisclosure();
	const qc = useQueryClient();

	/** Functions */
	async function handleOnComplete() {
		toast.success("SUCCSSS");
		await qc.invalidateQueries({ queryKey });
	}

	/** Render */
	return (
		<React.Fragment>
			<Button
				variant="primary"
				icon={<Icon name="Plus" />}
				onClick={addServiceFulfillmentPartnerModal.onOpen}
				data-cy="add-fulfillment-partner-button"
			>
				{t("organization.data.add_fulfillment_partner")}
			</Button>
			{addServiceFulfillmentPartnerModal.isOpen && (
				<AddServiceFulfillmentPartnerModal
					isOpen={addServiceFulfillmentPartnerModal.isOpen}
					onClose={addServiceFulfillmentPartnerModal.onClose}
					serviceId={serviceId}
					onComplete={handleOnComplete}
				/>
			)}
		</React.Fragment>
	);
}
